import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { CaseStatusResponse } from '../schema/case-status-schema'

export type CaseStatusState = {
  loading: boolean
  error: boolean
  data: CaseStatusResponse | null
}

const defaultCaseStatusState: CaseStatusState = {
  loading: false,
  error: false,
  data: null,
}

interface CitatorState {
  caseStatuses: Partial<Record<string, CaseStatusState>>
}

const initialState: CitatorState = {
  caseStatuses: {},
}

export const citatorSlice = createSlice({
  name: 'citatorState',
  initialState,
  reducers: {
    citatorStateAddCaseStatus: (state, action: PayloadAction<CaseStatusResponse>) => {
      const caseStatusState = state.caseStatuses[action.payload.parent_id] ?? defaultCaseStatusState
      state.caseStatuses[action.payload.parent_id] = { ...caseStatusState, data: action.payload }
    },
    citatorStateSetLoading: (state, action: PayloadAction<{ parent_id: string; loading: boolean }>) => {
      const caseStatusState = state.caseStatuses[action.payload.parent_id] ?? defaultCaseStatusState
      state.caseStatuses[action.payload.parent_id] = { ...caseStatusState, loading: action.payload.loading }
    },
    citatorStateSetError: (state, action: PayloadAction<{ parent_id: string; error: boolean }>) => {
      const caseStatusState = state.caseStatuses[action.payload.parent_id] ?? defaultCaseStatusState
      state.caseStatuses[action.payload.parent_id] = { ...caseStatusState, error: action.payload.error }
    },
  },
})

export const { citatorStateAddCaseStatus, citatorStateSetLoading, citatorStateSetError } = citatorSlice.actions

export default citatorSlice.reducer
